import React, { useEffect, useState } from "react";
import styles from "./FAQ.module.scss";
import classNames from "classnames/bind";
import * as apis from "../../apis";
import useScrollFadeIn from "../../hooks/useScrollFadeIn";
import parse from "html-react-parser";

const cx = classNames.bind(styles);

export default function FAQ({ id }) {
  const [openId, setOpenId] = useState(null);

  const [data, setData] = useState([]);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apis.getAskedQuestions();
        setData(res.data.items);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  return (
    <div id={id} className={cx("container")}>
      <div className={cx("inner")}>
        <div className={cx("section-title-box")}>
          <p
            {...useScrollFadeIn("up", 1, 0.1)}
            className={`${cx("section-title")} font-play-700 `}
          >
            FAQ
          </p>
          <div className={cx("title-box")}>
            <p {...useScrollFadeIn("up", 1, 0.2)} className={cx("title")}>
              자주 묻는 질문<b className={cx("title-b")}>.</b>
            </p>
          </div>
          <p {...useScrollFadeIn("up", 1, 0.3)} className={cx("text")}>
            도움이 필요하신가요? 여기서 모든 답을 찾아보세요.
          </p>
        </div>
        <div {...useScrollFadeIn("up", 1, 0.3)}>
          {data.length > 0 && (
            <div className={cx("faq-inner")}>
              {data.map((item) => (
                <button
                  onClick={() => handleToggle(item.id)}
                  key={item.id}
                  className={cx("faq-item-box")}
                >
                  <img
                    className={cx(
                      openId === item.id
                        ? "active-faq-item-icon"
                        : "faq-item-icon",
                    )}
                    src="/images/Icon.png"
                    alt="Icon.png"
                  />
                  <div className={cx("faq-item-title-box")}>
                    <p
                      className={cx(
                        openId === item.id
                          ? "active-faq-item-title"
                          : "faq-item-title",
                      )}
                    >
                      {item.title}
                    </p>
                    {openId === item.id && (
                      <div className={cx("faq-item-text-box")}>
                        <div className={cx("faq-item-text")}>
                          {parse(item.content || "")}
                        </div>
                      </div>
                    )}
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
